import { Autocomplete, Box, Button, Chip, Stack, TextField } from "@mui/material";
import { Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import Loader3D from "../../../components/Loader/Loader3D";
import {
  changeBatchForInduvidualStudent,
  getBatchAdmissionRegister,
  getBatchesWithSameCourseExistNoPagination,
} from "../../../redux/features/batchSlice";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
const ChangeBatchLanding = ({ open, setOpen, rowData, dispatchParams }) => {
  const { loading,batchesWithSameCourse } = useSelector((state) => state.batch);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [correspondingSubjects, setCorrespondingSubjects] = useState([]);

  useEffect(() => {
    if (open) {
      dispatch(getBatchesWithSameCourseExistNoPagination({ isAllBatchesNeeded: false, courseId: rowData?.courseId }));
    }
  }, [open]);
  const initialValues = {
    batchId: "",
  };

  const schema = Yup.object({
    batchId: Yup.string().required("Batch is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      const data = {
        batchId: values.batchId,
        batch_assignment_id: [rowData.batch_assignment_id],
      };
      dispatch(changeBatchForInduvidualStudent(data)).then((res) => {
        if (res.payload.status === "error") {
          enqueueSnackbar(res.payload.message, { variant: "error" });
        } else if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, { variant: "success" });
          dispatch(getBatchAdmissionRegister(dispatchParams));
          handleCancel();
        }
      });
    },
  });
  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };
  return (
    <GlobalDialog
      maxWidth={"sm"}
      fullWidth
      title={"Change Batch"}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      content={
        open ? (
          loading ? (
            <Loader3D />
          ) : (
            <>
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Box>
                    <Stack gap={2}>
                      <Box>
                        <Autocomplete
                          name={"batchId"}
                          fullWidth
                          options={batchesWithSameCourse}
                          getOptionLabel={(option) => option.course_batch_name || ""}
                          value={batchesWithSameCourse?.find((data) => data?.course_batch_id == formik.values.batchId) || null}
                          onChange={(e, option) => {
                            formik.setFieldValue("batchId", option?.course_batch_id || "");
                            setCorrespondingSubjects(option?.subjects || []);
                          }}
                          renderInput={(params) => (
                            <TextField
                              error={formik.touched.batchId && Boolean(formik.errors.batchId)}
                              helperText={formik.touched.batchId && formik.errors.batchId}
                              fullWidth
                              autoComplete="off"
                              {...params}
                              label="Choose New Batch"
                            />
                          )}
                        />
                      </Box>
                    </Stack>
                    <Box p={1} display={"flex"} gap={0.5} flexWrap={"wrap"}>
                      {Array.isArray(correspondingSubjects) &&
                        correspondingSubjects.map((sub, index) => (
                          <Chip
                            key={`${sub?.subject_id}`}
                            label={sub?.subject_name}
                            size="small"
                            sx={{
                              fontSize: {
                                xs: "0.6rem",
                                sm: "0.7rem",
                              },
                              fontWeight: 600,
                              p: 1,
                            }}
                          />
                        ))}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                    <Stack direction={"row"} spacing={1}>
                      <Button sx={{ boxShadow: "none" }} color="secondary" size="small" variant="contained" onClick={() => handleCancel()}>
                        Cancel
                      </Button>

                      <Button sx={{ boxShadow: "none" }} color="primary" size="small" variant="contained" type="submit">
                        {loading ? "Submiting..." : "Submit"}
                      </Button>
                    </Stack>
                  </Box>
                </Form>
              </FormikProvider>
            </>
          )
        ) : null
      }
    />
  );
};

export default ChangeBatchLanding;
